import type { Messages } from './en';

export const MESSAGES_DK: Messages = {
  secure_tagadapay: 'Sikker Betaling af Tagada',
  checkout_title: 'Sikker Betaling',
  checkout_subtitle: 'Fuldfør dit køb sikkert',
  express_payment: 'Ekspres Betaling',
  express_payment_apple_pay: 'Betal med Apple Pay',
  express_payment_subtitle: 'Spring checkout-formularen over',
  informations_title: 'Informationer',
  informations_subtitle: 'Indtast dine personlige oplysninger',
  shipping_address_title: 'Leveringsadresse',
  shipping_address_subtitle: 'Indtast din leveringsadresse',
  shipping_method_title: 'Leveringsmetode',
  shipping_method_subtitle: 'Vælg din leveringsmetode nedenfor',
  shipping_method_warning_title: 'Information',
  shipping_method_warning_text: 'Ingen leveringsmetode fundet i dit land',
  billing_address_check: 'Faktureringsadresse er forskellig fra leveringsadresse',
  billing_method_title: 'Faktureringsmetode',
  billing_method_subtitle: 'Indtast din faktureringsadresse',
  payment_title: 'Betaling',
  payment_subtitle: 'Vælg din betalingsmetode nedenfor. Alle transaktioner er sikre og krypterede',
  payment_credit_card: 'Kredit- eller debetkort',
  payment_credit_card_subtitle: 'Sikker kortbetaling',
  payment_paypal_subtitle: 'Sikker og hurtig betaling med PayPal',
  payment_bridge_subtitle: 'Sikker og hurtig betaling med Bridge',
  payment_klarna_subtitle: 'Sikker og hurtig betaling med Klarna',
  payment_generic_subtitle: 'Sikker og hurtig betaling',
  default_payment_method_short: 'Standard',
  order_summary_discount_code: 'Rabatkode',
  order_summary_discount_discovered_callout: 'Vi fandt rabatkoder til dig!',
  order_summary_discount_discovered_callout_action: 'Tilføj dem alle',
  order_summary_title: 'Din ordre',
  order_summary_subtotal: 'Subtotal',
  order_summary_shipping: 'Levering',
  order_summary_discount: 'Rabat',
  order_summary_tax: 'Estimerede skatter',
  order_summary_total: 'Total',
  order_summary_total_savings: 'Besparelser',
  button_pay: 'Betal nu',
  button_pay_with_gateway: 'Betal med {gateway}',
  loading: 'Indlæser...',
  error_missing_checkout_session_id: 'Manglende checkout-sessions-id',
  error_checkout_session_not_found: 'Checkout-session ikke fundet',
  error_order_already_completed: 'Ordre allerede fuldført',
  error_checkout_session_items_empty: 'Din kurv er tom',
  order_not_found: 'Ordre ikke fundet',
  thank_you_title: 'Tak for din ordre!',
  thank_you_subtitle: 'Din ordre er blevet behandlet med succes.',
  thank_you_email_sent: 'Vi har sendt en bekræftelses-e-mail til din registrerede e-mailadresse:',
  thank_you_order_details: 'Ordredetaljer',
  thank_you_reference: 'Reference',
  thank_you_date: 'Dato',
  thank_you_total: 'Total',
  thank_you_button_continue: 'Fortsæt med at handle',
  term_and_privacy_clicking_text: 'Ved at klikke accepterer jeg',
  term_and_condition_link_text: 'Vilkår og betingelser',
  privacy_policy_link_text: 'Privatlivspolitik',
  refund_policy_link_text: 'Refusionspolitik',
  shipping_policy_link_text: 'Leveringspolitik',
  billed_as_text: 'Dit kreditkort vil blive opkrævet som {domain}.',
  you_must_accept_policies: 'Du skal acceptere vores',
  and: 'og',
  comma: ',',
  payment_error_title: 'Fejl',
  checkout_preview_title: 'Forhåndsvisningstilstand - Dette er en udkast til checkout-side',
  order_summary_discount_code_apply_button: 'Anvend',
  optional: 'Valgfri',
  field_phone: 'Telefon',
  field_phone_placeholder: 'Indtast dit telefonnummer',
  field_phone_required_text: 'Telefonnummer er påkrævet',
  field_company: 'Virksomhed',
  field_company_placeholder: 'Indtast dit firmanavn',
  checkbox_billing_address: 'Faktureringsadresse er forskellig fra leveringsadresse',
  billing_address_title: 'Faktureringsadresse',
  billing_address_subtitle: 'Indtast din faktureringsadresse',
  field_first_name: 'Fornavn',
  field_first_name_placeholder: 'Indtast dit fornavn',
  field_first_name_error_message: 'Dette felt er påkrævet',
  field_last_name: 'Efternavn',
  field_last_name_placeholder: 'Indtast dit efternavn',
  field_last_name_error_message: 'Dette felt er påkrævet',
  field_address: 'Adresse',
  field_address_placeholder: '123 Hovedgade, By, Land',
  field_address_error_message: 'Dette felt er påkrævet',
  field_additional_address: 'Yderligere adresse',
  field_additional_address_placeholder: 'Lejlighed, suite, enhed, osv.',
  field_additional_address_error_message: 'Dette felt er påkrævet',
  field_city: 'By',
  field_city_placeholder: 'Indtast din by',
  field_city_error_message: 'Dette felt er påkrævet',
  field_country: 'Land',
  field_country_error_message: 'Dette felt er påkrævet',
  field_state: 'Stat/Region',
  field_state_placeholder: 'Indtast din stat/region',
  field_state_error_message: 'Dette felt er påkrævet',
  field_postal_code: 'Postnummer',
  field_postal_code_placeholder: 'Indtast dit postnummer',
  field_postal_code_error_message: 'Dette felt er påkrævet',
  field_email: 'E-mail',
  field_email_placeholder: 'Indtast din e-mail',
  field_email_error_message: 'Dette felt er påkrævet',
  credit_card_method: 'Kredit- eller debetkort',
  card_error_message: 'Ugyldig kortinformation',
  card_number: 'Kortnummer',
  card_number_placeholder: 'Indtast dit kortnummer',
  card_number_error_message: 'Dette felt er påkrævet',
  expiry_date: 'Udløbsdato',
  expiry_date_placeholder: 'MM/ÅÅ',
  expiry_date_error_message: 'Dette felt er påkrævet',
  expiry_date_error_message_expired: 'Udløbsdatoen er overskredet',
  cvc: 'CVC/CVV',
  cvc_placeholder: '123',
  cvc_error_message: 'CVC skal være 3 eller 4 cifre',
  payment_methods_loading_error: 'Kunne ikke indlæse betalingsmetoder',
  recommanded: 'Anbefalet',
  free: 'Gratis',
  customer_update_error: 'Kunne ikke opdatere informationer',
  shipping_method_empty_country: 'Vælg et land for at se tilgængelige leveringsmetoder',
  shipping_method_update_error: 'Kunne ikke opdatere leveringsmetodeinformationer',
  items: '{count} varer',
  back: 'Tilbage',
  continue_to_shipping: 'Fortsæt til levering',
  continue_to_payment: 'Fortsæt til betaling',
  contact_title: 'Kontakt',
  contact_title_subtitle: 'Indtast dine kontaktoplysninger',
  pay_now: 'Betal nu',
  secure_payment_message: 'Alle transaktioner er sikre og krypterede',
  interval_day: 'dag',
  interval_week: 'uge',
  interval_month: 'måned',
  interval_year: 'år',
  interval_day_plural: 'dage',
  interval_week_plural: 'uger',
  interval_month_plural: 'måneder',
  interval_year_plural: 'år',
  every_interval: 'Hver {count} {interval}',
  billing_every_interval: 'Fakturering hver {count} {interval}',
  delivery_every_interval: 'Levering hver {count} {interval}',
  free_trial_period: '{duration} {type} gratis prøveperiode',
  first_payment_free: 'Første betaling gratis',
  subscription_trial_notice:
    'Dit abonnement inkluderer en gratis prøveperiode. Du bliver ikke opkrævet før prøveperioden slutter.',
  recurring_total_with_interval: 'Tilbagevendende total (hver {count} {interval})',
  trial_ends_on: 'Prøveperioden slutter den {date}',
  billing_timing: 'Fakturering: {timing}',
  billing_cycle_anchor: 'Faktureringscyklus anker',
  field_marketing_label: 'Accepter at modtage marketing-e-mails',
  terms_acceptance_text: 'Ved at klikke accepterer jeg',
  cart_title: 'Kurv',
  payment_failed_message: 'Betaling mislykkedes',
  email: {
    abandoned_checkout: {
      preview: 'Fuldfør dit køb',
      default_body: 'Vi bemærkede, at du efterlod nogle varer i din kurv. Vil du gerne fuldføre dit køb?',
      cart_title: 'Din kurv',
      quantity: 'Antal',
      recurring: 'Tilbagevendende hver {interval}',
      trial_period: '({duration} {type} prøve)',
      subtotal: 'Subtotal',
      discounts: 'Rabatter',
      total: 'Total',
      cta_button: 'Fuldfør dit køb',
      footer_text: 'Hvis du har spørgsmål, så svar bare på denne e-mail - vi hjælper altid gerne.',
    },
    order_paid: {
      // Add order paid email translations here when needed
    },
  },
  image_upload: {
    errors: {
      unauthorized: 'Uautoriseret',
      unsupported_content_type: 'Ikke-understøttet indholdstype',
      single_file_required: 'En enkelt fil er påkrævet',
      file_too_big: 'Filen er for stor',
      non_image_file: 'Kan ikke håndtere ikke-billedfiler',
    },
  },
  promotion_code_invalid: 'Denne rabatkode er ikke gyldig',
  applying: 'Anvender...',
  processing_payment: 'Behandler betaling...',
  select_country: 'Vælg et land',
  select_state: 'Vælg en stat',
  order_details: 'Ordredetaljer',
  order_number: 'Ordrenummer',
  order_date: 'Ordredato',
  email_confirmation: 'E-mail bekræftelse',
  confirmation_sent_to: 'Bekræftelses-e-mail sendt til',
  shipping_address: 'Leveringsadresse',
  billing_address: 'Faktureringsadresse',
  payment_successful: 'Betaling lykkedes',
  recurring_total: 'Tilbagevendende total',
  payment_is_blacklisted: 'Betaling er sortlistet',
  checkout_has_errors_title: 'Validering',
  checkout_has_errors: 'Informationerne nedenfor er ugyldige eller mangler',
  checkout_email_error: 'e-mailadresse',
  checkout_shipping_address_error: 'leveringsadresse',
  checkout_billing_address_error: 'faktureringsadresse',
  checkout_shipping_rate_error: 'leveringstarif',
  checkout_pickup_address_error: 'afhentningsadresse',
  checkout_payment_info_error: 'betalingsinformationer',
  checkout_phone_error: 'telefonnummer',
  checkout_terms_error: 'du har ikke accepteret vilkårene og betingelserne',
  payment: {
    genericError: 'Payment failed. Please try again with a different payment method.',
  },
  error: {
    unexpected: 'Der opstod en uventet fejl. Prøv venligst igen.',
  },
  checkout_completed_title: 'Checkout fuldført',
  checkout_already_completed: 'Denne ordre er allerede blevet betalt',
  payment_completed: 'Betaling fuldført',
  apply_vip_offers: 'Betal nu som VIP',
  confirm_vip_payment: 'Bekræft VIP-betaling',
  cancel_vip_offers: 'Annuller VIP-tilbud',
  vip_total_difference: 'Forskel: {difference}',
  total_as_vip: 'VIP',
  vip_savings: 'VIP-besparelser',
  vip_savings_available: 'VIP-besparelser tilgængelige',
  vip_savings_confirmed: 'VIP-besparelser anvendt',
  vip_savings_message: 'Vælg VIP-betaling for at låse disse besparelser op!',
  vip_savings_applied_message: 'Du sparer {amount} med VIP-fordele!',
  vip_offer_savings_confirmed: 'VIP-tilbud anvendt',
  vip_offer_savings_available: 'VIP-tilbud tilgængeligt',
  vip_offer_savings_message: 'Anvend VIP-tilbuddet for at spare på din ordre',
  vip_offer_savings_applied_message: 'Du sparede {amount} med VIP-tilbuddet',
  apply_vip_offer: 'Anvend VIP-tilbud',
  cancel_vip_offer: 'Annuller VIP-tilbud',
  you_save: 'Du sparer {amount}',
  you_save_on_order: 'Du sparer {amount} på din ordre',
  you_save_available: 'Spar {amount} på din ordre med det eksklusive VIP-tilbud',
  free_trial_then_price: '{duration} {type} gratis prøveperiode, derefter {price}/{interval}',
  free_trial_period_short: '{duration} {type} gratis',
  click_to_apply: 'Klik for at anvende',
  please_select_shipping_country: 'Vælg venligst et land for at se tilgængelige leveringsmetoder',
  invalid_phone_number: 'Ugyldigt telefonnummer',
  click_errors_to_navigate: 'Klik for at navigere til fejl',
  pickup_point: 'Afhentningssted',
  monday: 'Mandag',
  tuesday: 'Tirsdag',
  wednesday: 'Onsdag',
  thursday: 'Torsdag',
  friday: 'Fredag',
  saturday: 'Lørdag',
  sunday: 'Søndag',
  promotion_code_usage_limit_reached: 'Denne kampagnekode har nået sin brugsgrænse',
  promotion_code_first_time_only: 'Denne kampagnekode er kun gyldig for førstegangskunder',
  promotion_code_invalid_email: 'Denne kampagnekode er ikke gyldig for din e-mailadresse',
  promotion_code_cannot_apply: 'Denne kampagnekode kan ikke anvendes',
  promotion_code_already_applied: 'Denne kampagne er allerede anvendt',
  promotion_code_expired: 'Denne kampagnekode er udløbet',
  promotion_code_cannot_remove_auto: 'Kan ikke fjerne automatisk anvendte kampagner',
  promotion_code_remove_failed: 'Kunne ikke fjerne kampagnekode',
  remove: 'Fjern',
  pickup_select_point: 'Vælg afhentningssted',
  pickup_select_point_description: 'Vælg et afhentningssted tæt på dig',
  pickup_click_to_select: 'Klik for at vælge',
  pickup_change_point: 'Skift afhentningssted',
  pickup_change: 'Skift',
  pickup_opening_hours: 'Åbningstider',
  pickup_closed: 'Lukket',
  pickup_point_error: 'Der opstod en fejl ved valg af afhentningssted',
  pickup_view_list: 'Listevisning',
  pickup_view_map: 'Kortvisning',
  pickup_open_map: 'Åbn kort',
  pickup_open_map_description: 'Klik for at åbne det interaktive kort',
  pickup_no_points_found: 'Ingen afhentningssteder fundet i dette område',
  cancel: 'Annuller',
  order_confirmed: 'Ordre bekræftet',
  view_order_details: 'Se ordredetaljer',
  back_to_portal: 'Tilbage til portal',
  customer_details: 'Kundedetaljer',
  customer_email: 'E-mail',
  customer_id_label: 'Kunde-ID',
  customer_first_name: 'Fornavn',
  customer_last_name: 'Efternavn',
  customer_locale: 'Sprog',
  marketing_consent: 'Marketingpræferencer',
  marketing_accepted: 'Tilmeldt marketing',
  marketing_declined: 'Ikke tilmeldt marketing',
  customer_created_at: 'Kunde siden',
  order_status_label: 'Ordrestatus',
  order_status_paid: 'Betalt',
  order_status_pending: 'Afventende',
  order_status_cancelled: 'Annulleret',
  post_purchase: {
    title: 'Vi fandt disse tilbud specielt til dig',
    view_deal: 'Se tilbud',
    get_deal_now: 'Få tilbud nu',
    bundle_content: '{count, plural, =0 {ingen varer} =1 {# vare} other {# varer}}',
    adding_to_cart: 'Behandler...',
    vip_only: 'Kun VIP',
    products: '{count, plural, =0 {Ingen produkter} =1 {# produkt} other {# produkter}}',
    skip: 'spring over',
    skip_addition: 'gå til dit resume',
    exclusive_offer: 'Eksklusivt engangstilbud',
    offer_expires_in: 'Tilbud udløber om',
    minutes: 'min',
    save: 'Spar',
    secure_checkout: 'Sikker checkout',
    safe_payment: 'Køberbeskyttelse garanteret',
    limited_time_offer: 'Begrænset tidstilbud',
    previous: 'Forrige',
    no_thanks: 'Nej tak',
    offer_count: 'Tilbud {current} af {total}',
    special_offer_title: 'Særligt tilbud til dig',
  },
  billing_plan: 'Faktureringsplan',
  customer: 'Kunde',
  current_period: 'Nuværende periode',
  trial_period: 'Prøveperiode',
  cancellation_notice: 'Annulleringsmeddelelse',
  subscription_cancellation_end_period:
    'Dette abonnement vil blive annulleret ved slutningen af den nuværende periode.',
  created: 'Oprettet',
  product_id: 'Produkt-ID',
  resuming: 'Genoptager...',
  resume_subscription: 'Genoptag abonnement',
  canceling: 'Annullerer...',
  cancel_subscription: 'Annuller abonnement',
  my_subscriptions: 'Mine abonnementer',
  subscriptions: 'abonnementer',
  no_active_subscriptions: 'Du har ingen aktive abonnementer.',
  active: 'Aktiv',
  trial: 'Prøve',
  loading_subscriptions: 'Indlæser dine abonnementer...',
  qty: 'Antal',
  id: 'ID',
  by_canceling: 'Ved at annullere vil du:',
  lose_club_advantages: 'Miste alle fordele ved at være medlem af klubben',
  lose_accumulated_credits: 'Miste alle credits, du har akkumuleret indtil nu',
  lose_promotion_code: 'Miste din personlige kampagnekode med eksklusive tilbud på hele butikken',
  confirm_proceed: 'Er du sikker på, at du vil fortsætte?',
  cancel_club_membership:
    'Dette vil annullere dit klubmedlemskab ved slutningen af den nuværende faktureringscyklus.',
  cancel_subscription_notice:
    'Dette vil annullere dit abonnement ved slutningen af den nuværende faktureringscyklus.',
  keep_subscription: 'Behold abonnement',
  yes_lose_benefits: 'Ja, jeg vil miste alle fordele ved at være medlem af Subclub',
  yes_cancel: 'Ja, annuller',
  cancel_subscription_title: 'Annuller abonnement',
  membership: 'Medlemskab',
  related_orders: 'Relaterede ordrer',
  related_orders_description: 'Ordrer foretaget gennem efter-køb tilbud',
  order_status: 'Status',
  order_total: 'Total',
  order_items: 'Varer',
  order_type: 'Type',
  view_order: 'Se ordre',
  order_item_count: '{count, plural, =1 {# vare} other {# varer}}',
  related_order_from: 'Fra {offerType} tilbud',
  no_related_orders: 'Ingen relaterede ordrer',
  total_with_related_orders: 'Total med relaterede ordrer',
  discount_applied: 'Rabat anvendt',
  paid: 'Betalt',
  pending: 'Afventende',
  processing: 'Behandler',
  cancelled: 'Annulleret',
  refunded: 'Refunderet',
  vip_post_purchase: {
    title: 'Du har stadig tid!',
    subtitle: 'Tilmeld dig vores klubmedlemskab og vind stort!',
    action_cancel: 'Nej tak',
    action_subscribe: 'Tilmeld',
    savings: 'Du sparer {amount}',
    offer_title: 'Eksklusivt engangstilbud',
    offer_description: '',
  },
  shopify: {
    notes: {
      sendcloud_pickup: {
        id: 'Afhentningssted ID',
        name: 'Afhentningssted navn',
        street: 'Afhentningssted adresse',
        type: 'Afhentningssted type',
        city: 'Afhentningssted by',
        postal_code: 'Afhentningssted postnummer',
        country: 'Afhentningssted land',
        carrier: 'Afhentningssted fragtmand',
        code: 'Afhentningssted kode',
        latitude: 'Afhentningssted breddegrad',
        longitude: 'Afhentningssted længdegrad',
      },
    },
  },
};
